import { appConfig } from '../constants/generalConfig'
import io from 'socket.io-client'
import React from 'react'

export const socket = io.connect(appConfig.ws_base_url)
export const SocketContext = React.createContext()
